<template>
  <div class="hero-image site-header--fixed--top-by-height">
    <div class="hero-image__bg" v-if="useAsBackgroundImage">
      <div class="hero-image__bg__image" :style="getCssStyles">
        <transition name="fade">
          <h2 class="hero-image__title" v-if="initialized">
            <div v-text="getPageName + ' —'"></div>
            <div v-text="title"></div>
            <div v-if="afterTitleText" v-text="afterTitleText"></div>
          </h2>
        </transition>
      </div>
    </div>
    <img :src="src" :alt="title" v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: "HeroImage",
    props: {
        src: {required: true},
        title: {type: String},
        useAsBackgroundImage: {type: Boolean, default: true}
    },
    data() {
        return {
            initialized: false,
            afterTitleText: ""
        }
    },
    computed: {
      ...mapGetters(['getPageName']),
      getCssStyles() {
        console.log("hero: ", this.src)
        let styles = `background-image: url(${this.src})`;
        return styles;
      }
    },
    created() {
      setTimeout(() => {
        this.initialized = true
      }, 500)
    }
}
</script>

<style lang="scss" scoped>
@use "~@/assets/scss/abstracts/variables" as *;
.hero-image {
  position: relative;
  max-width: 1460px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  &__bg {
    height: 200px;
    transition: all .25s ease-in;
    &__image {
      height: 100%;
      position: relative;
      background-size: 140%;
      background-position: 60% 100%;
      transition: all .25s ease-in;
        &::before {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.35);
        }
    }
    @media screen and (min-width: $breakpoint-s) {
      &__image {
        background-size: 120%;
      }
    }
    @media screen and (min-width: $breakpoint-sm) {
      height: 250px;
      &__image {
        background-size: 100%;
      }
      .hero-image__bg__image {
        background-size: cover;
        background-position: 0% 100%;
      }
    }
    @media screen and (min-width: $breakpoint-md) {
      height: 300px;
    }
    @media screen and (min-width: $breakpoint-lg) {
      height: 400px;
      .hero-image__bg__image {
        background-position: 50% 85%;
      }
    }
    @media screen and (min-width: $breakpoint-xxl) {
      height: 450px;
      .hero-image__bg__image {
        background-position: 50% 78%;
      }
    }
  }
  &__title {
    position: absolute;
    @include font-primary-light;
    margin-block: 0;
    line-height: 1.5;
    font-size: 1.2rem;
    left: 50%;
    color: $brandColorPrimary;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: 65%;
    text-shadow: 1px 1px rgba(0,0,0,0.1);
    color: #fff;
    z-index: 1;

    @media screen and (min-width: $breakpoint-s) {
      font-size: 1.3rem;
    }

    @media screen and (min-width: $breakpoint-md) {
      font-size: 1.5rem;
    }

    @media screen and (min-width: $breakpoint-lg) {
      font-size: 2rem;
    }

  }
}
</style>